<!--
 * @Author: ymk
 * @Date: 2020-07-24 16:54:55
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-27 10:03:02
 * @FilePath: \car-demo\src\components\Navigate.vue
  @click="handleClick(item)"
  :href="item.menu_link"
-->
<template>
	<div class="navigate">
		<a
				v-for="(item, index) in list"

			class="navigate-item"
				@click="handleClick(item)"
			:key="index"
            :style="itemStyle"

		>

			<img class="navigate-icon" :src="item.icon" :alt="item.text" />
			<p>{{ item.text }}</p>
		</a>
	</div>
</template>

<script>
export default {
    name: 'navigate',
    props: {
        list: {
            type: Array,
            // 传入的数组
            // [{
            //     icon: '菜单图片地址'
            //     text: '菜单名称',
            // }]
            default: () => [
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
                {
                    icon: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1724911089,2923226954&fm=15&gp=0.jpg',
                    text: '抽奖',
                },
            ],
        }
    },
    computed: {
        itemStyle() {
            const count = this.list.length;
            const result = {}

            if(count < 3) {
                result['flex-grow'] = 1;
            }else if(count == 3) {
                result['flex-basis'] = 100/3 + '%';
            }else if(count == 4) {
                result['flex-basis'] = 100/4 + '%';
            }else if(count >= 5) {
                result['flex-basis'] = 100/5 + '%';
            }

            return result;
        }
    },
    methods: {
        handleClick(item) {
            var host = window.location.host;
            if(parseInt(item.link_type)  == 1){
				if(item.menu_link_detail !== null && item.menu_link_detail !== 'null'){
                    if(item.menu_link_detail.indexOf("maintain") != -1){
                        window.location.href = 'http://'+host+'/'+item.menu_link_detail+'/#/';
                    }else if(item.menu_link_detail.indexOf("businessList") != -1){
                        window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
                    }else{
                        this.$router.push({name: item.menu_link_detail, query: {}});
                    }
					
				}
			}else{
            	if(item.menu_link_detail !== null && item.menu_link_detail !== 'null'){
					window.location.href=item.menu_link_detail
				}
			}

            // this.$emit('click', item)
        }
    }
}
</script>

<style lang="less" scoped>
.navigate {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 14px 10px 14px;
	&-item {
        text-align: center;
        margin-bottom: 10px;
        font-size: 13px;
        color: rgba(51, 51, 51, 1);
    }
	&-icon {
		display: inline-block;
		width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-bottom: 6px;
	}
}
</style>
